import { Paper, Title, Text } from '@mantine/core';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { Asset } from '@/types/models';

interface AssetsByCategoryChartProps {
  assets: Asset[];
}

export function AssetsByCategoryChart({ assets }: AssetsByCategoryChartProps) {
  // Count assets by category
  const categoryCounts = assets.reduce(
    (acc, asset) => {
      const categoryName = asset.category?.name || 'Uncategorized';
      acc[categoryName] = (acc[categoryName] || 0) + 1;
      return acc;
    },
    {} as Record<string, number>
  );

  // Convert to chart data and sort by count
  const chartData = Object.entries(categoryCounts)
    .map(([category, count]) => ({
      category,
      count,
    }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10); // Top 10 categories

  if (chartData.length === 0) {
    return (
      <Paper withBorder p="lg" radius="md">
        <Title order={3} mb="md">
          Assets by Category
        </Title>
        <Text c="dimmed" ta="center" py="xl">
          No assets to display
        </Text>
      </Paper>
    );
  }

  return (
    <Paper withBorder p="lg" radius="md">
      <Title order={3} mb="md">
        Assets by Category
      </Title>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="category" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" fill="#339af0" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
